import { render, staticRenderFns } from "./ElSwitch.vue?vue&type=template&id=5a4b3095&scoped=true&"
import script from "./ElSwitch.vue?vue&type=script&lang=js&"
export * from "./ElSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ElSwitch.vue?vue&type=style&index=0&id=5a4b3095&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4b3095",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
